import { graphql } from '@generated/gql';

export const FETCH_ALERT_BANNER_NAME = graphql(/** GraphQL */ `
  query alertBannerBreadcrumbFetchAlertBannerName($alertBannerId: ObjectID!) {
    fetchAlertBanner(alertBannerId: $alertBannerId) {
      alertBanner {
        name
      }
    }
  }
`);
